var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isLazy)?_c('el-image',_vm._b({key:_vm.guid(),attrs:{"src":_vm.imgUrl,"alt":_vm.$attrs.alt,"lazy":""}},'el-image',_vm.$attrs,false)):_c('img',_vm._b({attrs:{"src":_vm.imgUrl,"alt":_vm.$attrs.alt,"lazy":""}},'img',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }